import { Link, useLocation } from 'react-router-dom';
import React from 'react';
import { Breadcrumb } from 'react-bootstrap';

export const Breadcrumbs = () => {
  const location = useLocation();
  const paths = location.pathname.split('/').filter((p) => p);

  return (
    <Breadcrumb>
      <Breadcrumb.Item href="/">
        Avaleht
      </Breadcrumb.Item>
      {paths.map((path, index) => {
        const url = `/${paths.slice(0, index + 1).join('/')}`;
        const isLast = index === paths.length - 1;
        return (
          <Breadcrumb.Item key={url} active={isLast} href={url}>
            {isLast ? (
              <span>{mapUrlToName(url)}</span>
            ) : (
              mapUrlToName(url)
            )}
          </Breadcrumb.Item>
        );
      })}
    </Breadcrumb>
  );
};

const mapUrlToName = (url) => {
  const mapping = {
    '/admin': 'Administreerimine',
    '/admin/match_details': 'Matši detailid',
    '/match_details': 'Matši detailid',
    '/admin/add_match': 'Matši lisamine',
    '/admin/edit_match': 'Matši muutmine',
    '/team_details': 'Võistkonna detailid',
    '/clubs': 'Klubid',
    '/future_matches': 'Eelolevad mängud',
  };
  return mapping[url] || url;
};
